/**
 * Route-loading skeleton.
 *
 * Replaces the old centered-logo spinner with a page-shaped placeholder
 * that approximates the route's layout (hud strip + title + content grid).
 * The brain reads "page is loading" instead of "app is hung".
 *
 * Rendered inside <AppLayout> which already paints the TopNav, so we only
 * need to fill the content area.
 */

export default function LoadingFallback() {
  return (
    <div
      style={{
        maxWidth: "var(--page-max-width)",
        margin: "0 auto",
        padding: "var(--page-padding-y) var(--page-padding-x)",
        animation: "fadeIn 160ms var(--ease-smooth) forwards",
        opacity: 0,
      }}
    >
      {/* HUD strip hint */}
      <div style={{ display: "flex", gap: 10, marginBottom: 16 }}>
        <div className="skeleton" style={{ width: 74, height: 24, borderRadius: "var(--radius-pill)" }} />
        <div className="skeleton" style={{ width: 110, height: 24, borderRadius: "var(--radius-pill)" }} />
        <div className="skeleton" style={{ width: 90, height: 24, borderRadius: "var(--radius-pill)" }} />
      </div>

      {/* Page title */}
      <div className="skeleton" style={{ width: "48%", maxWidth: 360, height: 42, borderRadius: 8, marginBottom: 10 }} />
      <div className="skeleton" style={{ width: "30%", maxWidth: 220, height: 14, borderRadius: 6, marginBottom: 28 }} />

      {/* Content grid — 6 tiles to hint at Library / Templates shape */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
          gap: 16,
        }}
      >
        {Array.from({ length: 6 }).map((_, i) => (
          <div
            key={i}
            className="skeleton"
            style={{
              aspectRatio: i % 3 === 0 ? "4 / 3" : i % 3 === 1 ? "1 / 1" : "3 / 4",
              borderRadius: "var(--radius-lg)",
            }}
          />
        ))}
      </div>
    </div>
  );
}
